module.exports = __webpack_public_path__ + "static/media/stevePic.89fa821c.jpeg";